import { useState } from "react";
import classNames from "../../utils/classNames";
import DashboardTile from "./DashboardTile";


interface DashboardTileMultipleProps {
  values: string[];
  labels: string[];
  subLabels: string[];
  colour?: string;
  borderless?: boolean;
  className?: string;
};

export default function DashboardTileMultiple({ values, labels, subLabels, colour = "slate", borderless = false,  className = '' }: DashboardTileMultipleProps) {
  const [tileStage, setTileStage] = useState(0);

  const circleCss = "rounded-full h-2 w-2 bg-gray-600";

  const getOpacity = (card: number) => {
    if (tileStage === card) {
      return "opacity-100";
    } else {
      return "opacity-60";
    }
  };

  const handleTileStage = () => {

    if (tileStage === values.length - 1) {
      setTileStage(0);
    } else {
      setTileStage(tileStage + 1);
    }
  };

  const content = (
    <div
        className={`h-full rounded bg-${colour}-100 text-${colour}-600 p-2 px-4 prose-base hover:bg-${colour}-200 select-none cursor-pointer ${className}
          transition-transform hover:scale-105`}
        onClick={() => handleTileStage()}
      >
      <div className="flex justify-between">
        <h1 className={`text-${colour}-600 font-semibold text-2xl`}>
          {values[tileStage]}
        </h1>
        <div className="flex gap-x-1">
          {values.map((_, i) => (
            <div
              key={i}
              className={classNames(getOpacity(i), circleCss)}
            ></div>
          ))}
        </div>
      </div>
      <p className="!m-0 text-sm">{labels[tileStage]}</p>
      <p className="!m-0 text-xs">{subLabels[tileStage]}</p>
    </div>
  );

  if(borderless) return (<>{content}</>)

  return (
    <DashboardTile>
      {content}
    </DashboardTile>
  )
}